import React, { useState } from 'react';
import { ConversationDW } from '../../ConversationGroup.styled';
import DwUsers from './components/dwUsers/DwUsers';
import DwSelect from './components/dwSelect/DwSelect';

const ConversationDwUsers = ({ selectedTicket, loadData }) => {
	const [dwSavedUsers, setDwSavedUsers] = useState([]);

	return (
		<ConversationDW>
			{!!dwSavedUsers?.length && (
				<DwUsers
					dwSavedUsers={dwSavedUsers}
					selectedTicket={selectedTicket}
					loadData={loadData}
				/>
			)}
			<DwSelect
				dwSavedUsers={dwSavedUsers}
				setDwSavedUsers={setDwSavedUsers}
				selectedTicket={selectedTicket}
				loadData={loadData}
			/>
		</ConversationDW>
	);
};

export default ConversationDwUsers;
